import LabelHistoryOperation from './label-history_operation.js';
export default LabelHistoryOperation;
